import React, { useEffect } from "react";
import { getMobileInstallUrl, HEREWEARE_INSTALL_URL } from "../home/utils/install";

export default function InstallRedirectPage() {
  useEffect(() => {
    window.location.replace(getMobileInstallUrl());
  }, []);

  return (
    <main className="flex min-h-screen items-center justify-center">
      <a href={HEREWEARE_INSTALL_URL}>Get the HereWeAre app</a>
    </main>
  );
}
